import { render, staticRenderFns } from "./funnel-chart.component.vue?vue&type=template&id=3042e900&scoped=true"
import script from "./funnel-chart.component.vue?vue&type=script&lang=ts"
export * from "./funnel-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./funnel-chart.component.vue?vue&type=style&index=0&id=3042e900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042e900",
  null
  
)

export default component.exports